import { render, staticRenderFns } from "./OutcomeBadge.vue?vue&type=template&id=4b582808"
import script from "./OutcomeBadge.vue?vue&type=script&lang=js"
export * from "./OutcomeBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports